import { render, staticRenderFns } from "./UnitsDashboard.vue?vue&type=template&id=2602bd57&scoped=true&"
import script from "./UnitsDashboard.vue?vue&type=script&lang=js&"
export * from "./UnitsDashboard.vue?vue&type=script&lang=js&"
import style0 from "./UnitsDashboard.vue?vue&type=style&index=0&id=2602bd57&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2602bd57",
  null
  
)

component.options.__file = "UnitsDashboard.vue"
export default component.exports